import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    textfield: {
        color: theme.brand.NormalText,
    },
}));

export default useStyles;
